module.exports = __webpack_public_path__ + "static/img/6.8f501e9b.jpg";